/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "01",
    asset: "1. Doanh thu bán hàng và cung cấp dịch vụ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 1,
    stt: "31",
    asset: "2. Doanh thu hoạt động tài chính và thu nhập khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 2,
    stt: "50",
    asset: "3. Tổng lợi nhuận kế toán trước thuế",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 3,
    stt: "60",
    asset: "4. Lợi nhuận sau thuế thu nhập doanh nghiệp",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
];

export default function Table2({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tính: VND
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Chi tiêu
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Mã số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuyết minh
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Quý 3
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Lũy kế từ đầu năm đến cuối quý này
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>Năm nay</Th>
              <Th style={{ textAlign: "center" }}>Năm trước</Th>
              <Th style={{ textAlign: "center" }}>Năm nay</Th>
              <Th style={{ textAlign: "center" }}>Năm trước</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>1</Th>
              <Th style={{ textAlign: "center" }}>2</Th>
              <Th style={{ textAlign: "center" }}>3</Th>
              <Th style={{ textAlign: "center" }}>4</Th>
              <Th style={{ textAlign: "center" }}>5</Th>
              <Th style={{ textAlign: "center" }}>6</Th>
              <Th style={{ textAlign: "center" }}>7</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  {rows.valueCenter && rows.valueCenter === true ? (
                    <>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.now}
                      </Td>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.before}
                      </Td>
                    </>
                  ) : (
                    <>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="now"
                          readOnly={rows.readOnly}
                          value={rows.value.now}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="before"
                          readOnly={rows.readOnly}
                          value={rows.value.before}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      {/*  */}
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="lknow"
                          readOnly={rows.readOnly}
                          value={rows.value.lknow}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="lkbefore"
                          readOnly={rows.readOnly}
                          value={rows.value.lkbefore}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
      <Footer formData={formData} />
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
